// extracted by mini-css-extract-plugin
module.exports = {"PrimaryLinksContainer":"styles_PrimaryLinksContainer__7xZoK","SecondaryLinksContainer":"styles_SecondaryLinksContainer__FAW59"};